/**
 * Supporting documents a user can attach to each Cargo Heating onboarding section.
 * `docType` is the `doc_type` sent to /cargoheating/onboarding/upload_document & get_document,
 * so it must stay stable once documents are stored against it.
 * Vessel Profile and Basic Details intentionally have no document.
 */
export interface ChOnboardingDocumentType {
  docType: string;
  label: string;
}

export const CH_ONBOARDING_DOCUMENT_TYPES = {
  'section-main-boiler': {
    docType: 'main_boiler_datasheet',
    label: 'Main boiler datasheet',
  },
  'section-composite-boiler': {
    docType: 'composite_boiler_datasheet',
    label: 'Composite boiler datasheet',
  },
  'section-egb-economizer': {
    docType: 'egb_economizer_datasheet',
    label: 'EGB / economizer datasheet',
  },
  'section-pipeline-configuration': {
    docType: 'steam_pipeline_drawing',
    label: 'Steam pipeline drawing',
  },
  'section-capacity-plan': {
    docType: 'capacity_plan',
    label: 'Capacity plan',
  },
  'section-heating-table': {
    docType: 'heating_coil_arrangement',
    label: 'Heating coil arrangement',
  },
  'section-boiler-efficiency-curve': {
    docType: 'boiler_efficiency_curve',
    label: 'Boiler efficiency curve',
  },
} as const satisfies Record<string, ChOnboardingDocumentType>;

export type ChOnboardingDocumentSection = keyof typeof CH_ONBOARDING_DOCUMENT_TYPES;
